var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"71vh"}},[_c('div',{staticClass:"spinner-grow text-primary",staticStyle:{"margin-top":"15%","margin-left":"45%"}})])}]

export { render, staticRenderFns }